/**
 * generic-oauth-error-codes
 * Adapted from @daveyplate/better-auth-ui
 * Enhanced for @bettercone/ui
 */

export const GENERIC_OAUTH_ERROR_CODES = {
    INVALID_OAUTH_CONFIGURATION: "Invalid OAuth configuration"
}
